export default __webpack_public_path__ + "static/media/device.6091a0a7.svg";